import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { WAREHOUSE_INTRO_SAMPLE, WAREHOUSE_INTRO_STOCK } from "../consts";
import { WarehouseSceneProps } from "../types";

/** Korak "Osnovni podaci": kartica skladišta s popunjenošću, zadnji prijem i sve na jednom mjestu. */
const WarehouseInfoScene: React.FC<WarehouseSceneProps> = ({ formValues }) => {
  const name = formValues.name || WAREHOUSE_INTRO_SAMPLE.name;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center w-11 h-11 rounded-md bg-blue-50 flex-shrink-0">
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M3 21V8l9-5 9 5v13M7 21v-8h10v8M7 17h10" />
              </svg>
            </span>
            <div className="min-w-0">
              <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Skladište</div>
              <div className="text-sm font-bold text-slate-800 truncate">{name}</div>
            </div>
          </div>

          <div className="mt-5 space-y-3">
            {WAREHOUSE_INTRO_STOCK.map((stock) => (
              <div key={stock.name}>
                <div className="flex justify-between text-[0.65rem]">
                  <span className="font-medium text-slate-600">{stock.name}</span>
                  <span className="text-slate-400">{stock.count}</span>
                </div>
                <div className="mt-1 h-1.5 w-full rounded-full bg-slate-100">
                  <div className={`h-1.5 rounded-full bg-blue-500 ${stock.width}`} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Zadnji prijem</div>
          <div className="mt-2 text-xs font-bold text-slate-800">Michelin Alpin 6</div>
          <div className="text-[0.65rem] text-slate-400">205/55 R16 · 4 kom</div>
          <div className="mt-3 inline-flex px-2 py-0.5 rounded-full text-[0.65rem] font-semibold bg-emerald-100 text-emerald-700">
            Uskladišteno
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Uvijek znate što je gdje"
          subtitle="Gume i oprema po skladištima"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(WarehouseInfoScene);
